import { apiPost } from './api'

// Reporte de errores del front (patrón Carpenter). El endpoint /api/clientlog ya
// existía y nadie lo llamaba: un crash en producción solo dejaba un console.error
// en la máquina de quien lo sufrió, así que nadie se enteraba nunca.
//
// Reglas, todas para que la telemetría NUNCA moleste ni haga daño:
//  · TOPE POR SESIÓN: un bucle de render podría disparar cientos de reportes y
//    convertir un bug de UI en una tormenta contra la API.
//  · DEDUPE: el mismo error repetido se manda una vez.
//  · SILENCIOSO: si el reporte falla (sin red, 401), se traga. Reportar un error
//    jamás debe provocar otro.
//  · Solo en producción: en desarrollo la consola ya es suficiente y ensuciaría
//    Firestore con ruido de HMR.

const TOPE = 5
let enviados = 0
const vistos = new Set<string>()

// Quedarse sin red NO es un crash. Sin este filtro, una persona en el metro
// generaría decenas de reportes de 'Sin conexión' y ahogaría los errores reales.
function esRuidoDeRed(msg: string): boolean {
  return /sin conexión|failed to fetch|networkerror|load failed|tardó demasiado/i.test(msg)
}

export function reportClientError(message: string, stack?: string): void {
  if (!import.meta.env.PROD) return
  if (enviados >= TOPE) return

  const msg = String(message ?? '').slice(0, 500)
  if (esRuidoDeRed(msg)) return
  const huella = msg.slice(0, 120)
  if (vistos.has(huella)) return
  vistos.add(huella)
  enviados += 1

  void apiPost('/api/clientlog', {
    message: msg,
    stack: String(stack ?? '').slice(0, 2000),
    url: typeof location !== 'undefined' ? location.pathname + location.search : '',
  }).catch(() => {
    /* best-effort: la telemetría no puede romper nada */
  })
}

// Errores que NO pasan por el ErrorBoundary: los de fuera del render (handlers,
// timers) y las promesas sin catch. En producción son la mayoría.
export function instalarCapturaGlobal(): void {
  if (typeof window === 'undefined') return
  window.addEventListener('error', (e) => {
    reportClientError(e.message || 'error', e.error?.stack)
  })
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason as { message?: string; stack?: string } | undefined
    reportClientError(r?.message ?? String(e.reason ?? 'promesa rechazada'), r?.stack)
  })
}
